export interface DiabguideRecommendationArgs {
  cardioRisk: Record<string, unknown>;
  glycemicObjectives: {
    hba: string;
    subtitle: string;
    note: string;
  };
  lipidObjectives: {
    ldl: string;
    note: string;
  };
  bloodPressureObjectives: {
    systolic: {
      label: string;
    };
    diastolic: {
      label: string;
    };
    note: string;
  };
  therapeuticStrategy: Record<string, unknown>[];
}

export default class DiabguideRecommendation {
  "cardioRisk": Record<string, unknown>;
  "glycemicObjectives": {
    hba: string;
    subtitle: string;
    note: string;
  };
  "lipidObjectives": {
    ldl: string;
    note: string;
  };
  "bloodPressureObjectives": {
    systolic: {
      label: string;
    };
    diastolic: {
      label: string;
    };
    note: string;
  };
  "therapeuticStrategy": Record<string, unknown>[];

  constructor(diabguideRecommendation: DiabguideRecommendationArgs) {
    const {
      cardioRisk,
      glycemicObjectives,
      lipidObjectives,
      bloodPressureObjectives,
      therapeuticStrategy
    } = diabguideRecommendation;
    this.cardioRisk = cardioRisk;
    this.glycemicObjectives = glycemicObjectives;
    this.lipidObjectives = lipidObjectives;
    this.bloodPressureObjectives = bloodPressureObjectives;
    this.therapeuticStrategy = therapeuticStrategy;
  }

  serialize(): DiabguideRecommendationArgs {
    return {
      cardioRisk: this.cardioRisk,
      glycemicObjectives: this.glycemicObjectives,
      lipidObjectives: this.lipidObjectives,
      bloodPressureObjectives: this.bloodPressureObjectives,
      therapeuticStrategy: this.therapeuticStrategy
    };
  }
}
